(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veladel-product-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.veladelReviewFormatting) return;
    window.veladelReviewFormatting = true;
    const formatReviews = () => {
      document.querySelectorAll('.product__info-container .jdgm-prev-badge').forEach(badge => {
        const rating = Number(badge.getAttribute('data-average-rating'));
        const count = Number(badge.getAttribute('data-number-of-reviews'));
        const label = badge.querySelector('.jdgm-prev-badge__text');
        let average = badge.querySelector('.veladel-review-average');
        if (!label || !count || !Number.isFinite(rating) || rating <= 0 || rating > 5) {
          if (average) average.remove();
          return;
        }
        if (!average) {
          average = document.createElement('span');
          average.className = 'veladel-review-average';
          label.before(average);
        }
        const text = rating.toLocaleString(document.documentElement.lang || 'fr', { minimumFractionDigits: 1, maximumFractionDigits: 2 }) + '/5 ·';
        if (average.textContent !== text) average.textContent = text;
      });
      document.querySelectorAll('.jdgm-rev__author, .jm-reviewer-info__name').forEach(author => {
        const name = author.textContent.trim();
        if (!name || name.includes('*')) return;
        const parts = name.split(/\s+/);
        if (parts.length < 2) return;
        const masked = parts[0] + ' ' + Array.from(parts[parts.length - 1])[0].toLocaleUpperCase() + '***';
        if (name !== masked) author.textContent = masked;
        if (author.hasAttribute('title')) author.setAttribute('title', masked);
      });
      document.querySelectorAll('.jm-reviewer-info__details > .jm-cluster > .jm-text:not(.jm-reviewer-info__name)').forEach(time => {
        const text = time.textContent.trim();
        if (time.getAttribute('data-veladel-formatted') === text) return;
        const match = text.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (!match) return;
        const date = match[2] + '/' + match[1] + '/' + match[3];
        time.setAttribute('data-veladel-formatted', date);
        if (text !== date) time.textContent = date;
      });
      document.querySelectorAll('.jdgm-rev__timestamp').forEach(time => {
        const source = time.getAttribute('datetime') || time.getAttribute('data-content') || '';
        const match = source.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!match) return;
        const date = match[3] + '/' + match[2] + '/' + match[1];
        if (time.textContent !== date) time.textContent = date;
        if (time.getAttribute('data-veladel-date') !== date) time.setAttribute('data-veladel-date', date);
        time.classList.remove('jdgm-spinner');
      });
    };
    let pending = false;
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; formatReviews(); });
    };
    const start = () => {
      formatReviews();
      new MutationObserver(schedule).observe(document.body, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['data-average-rating', 'data-number-of-reviews', 'datetime', 'data-content'] });
      document.addEventListener('shopify:section:load', schedule);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
